import * as React from 'react'
import TextContainer from '../../layout/TextContainer';
import TerminalChannelHeuristicsTable from './TerminalChannelHeuristicsTable';
import TerminalStablePeers from './TerminalStablePeers';



type Props = {
  nodeId: string,
  className?: string
}

const TerminalStablePeersSection: React.FC<Props> = ({ nodeId, className = '' }) => {

  return (
    <div className={' ' + className}>



      <TextContainer >

        <h2 className="text-xl font-bold mb-2 text-gray-800">Good peers</h2>
        <p className="mb-2">
          A good peer is a node that is categorized as stable/good and you have a good channel with.
          Checkout <a href="#good-channel" className="underline">good channel heuristics</a> to determine
          why a specific channel and therefore peer is acknowledge by Terminal.
        </p>

        <TerminalStablePeers className="mt-6" nodeId={nodeId} />
      </TextContainer>

      <TextContainer className="mt-24">
        <h2 id="good-channel" className="text-xl font-bold mb-2 text-gray-800">Good channels heuristics</h2>
        <p className="mb-8">
          Terminal measures several metrics to determine if your channel is a good inbound/outbound channel.
        </p>

        <TerminalChannelHeuristicsTable />
      </TextContainer>
    </div>
  );
}

export default TerminalStablePeersSection;

